<template>
  <v-card outlined :loading="loadings.main_card" id="card_admin_list_view">
    <v-card-title> 
      {{ currentRouteName }}

      <v-spacer></v-spacer>

      <v-btn
        to="/admin/create"
        color="white"
        small
        active-class="red"
      >
      create new
      </v-btn>
    </v-card-title>


    <v-divider></v-divider>
    <admin-list v-model="loadings.main_card"></admin-list>
  </v-card>
</template>

<script>
import AdminList from "@/components/admin/AdminList.vue";
export default {
  data(){
    return {
      loadings: {
        main_card: false
      }
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  components: {
    AdminList,
  },
  created() {
  }
};
</script>

<style>
</style>